{
  "active": {
    "name": "active",
    "badge": "default"
  },
  "inactive": {
    "name": "inactive",
    "badge": "inactive"
  },
  "past": {
    "name": "past",
    "badge": "inactive"
  }
}
